<template>
  <div class="my-10 text-center text--secondary">
    <v-img :src="require('../assets/404/empty.png')"
      class="ml-auto mr-auto"
      max-width="100">
    </v-img>
    <p class="mt-8 mb-1 title font-weight-bold">
      Belum ada {{ content }}
    </p>
    <p class="caption">
      {{ content }} tidak ditemukan
    </p>
  </div>
</template>

<script>
  export default {
    props: [
      "content"
    ]
  }
</script>